<template>
  <div id="header">
<!--    <div class="header-content">-->
<!--      <div>-->
<!--        欢迎“{{ realName }}”登录-->
<!--      </div>-->
<!--      <div class="right_sec">-->
<!--        <span @click="goAccount">个人中心</span>-->
<!--        <a-divider type="vertical"/>-->
<!--&lt;!&ndash;        <span @click="goCart">购物车<a-icon type="shopping-cart" style="font-size: 16px"/></span>&ndash;&gt;-->
<!--&lt;!&ndash;        <a-divider type="vertical"/>&ndash;&gt;-->
<!--        <span @click="goHome">首页</span>-->
<!--      </div>-->
<!--    </div>-->

    <!-- 导航栏 -->
    <nav class="navbar">
      <div class="logo">
        <i><img src="@/assets/icon/gift.png" style="width: 26px"></i>
        <h1>积分商城</h1>
      </div>
      <div class="nav-links">
        <a @click="goHome" :class="$route.path === '/account' ? '' : 'active' ">首页</a>
        <a @click="goAccount" :class="$route.path === '/account' ? 'active' : '' ">个人中心</a>
      </div>
      <div class="user-info">
        <div class="user-points" v-if="jifen !== null">
          <i><img src="@/assets/icon/jifen.png" style="width: 15px;margin-bottom: 2px;" /></i>
          <span>{{ jifen }} 积分</span>
        </div>
        <div class="user-avatar">{{ realName?.slice(0,1) }}</div>
      </div>
    </nav>

  </div>
</template>
<script>
import {mapState} from "vuex";

export default {
  props: {
    jifen: {
      type: Number,
      default: () => null
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      realName: state => {
        return state.user.userInfo.realName
      }
    })
  },
  methods: {
    goAccount () {
      this.$router.push({
        path: 'account'
      })
    },
    goCart () {
      this.$router.push({
        path: 'cart'
      })
    },
    goHome () {
      this.$router.push({
        path: '/'
      })
    }
  }
}
</script>
<style lang="less" scoped>
/* 导航栏样式 */
.navbar {
  background: linear-gradient(135deg, #a1c4fd, #c2e9fb);
  padding: 15px 5%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo i {
  font-size: 28px;
  color: #fff;
  background: linear-gradient(135deg, #ff9a9e, #fad0c4);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo h1 {
  font-size: 24px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 0.1em;
}

.nav-links {
  display: flex;
  gap: 30px;
}

.nav-links a {
  color: #2c3e50;
  text-decoration: none;
  font-weight: 500;
  font-size: 16px;
  transition: all 0.3s ease;
  padding: 8px 12px;
  border-radius: 5px;
}

.nav-links a:hover {
  background-color: rgba(255, 255, 255, 0.4);
}

.nav-links a.active {
  background-color: rgba(255, 255, 255, 0.6);
}

.user-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.user-points {
  background: linear-gradient(135deg, #ffecd2, #fcb69f);
  padding: 8px 18px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #2c3e50;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
}

.user-points i {
  color: #e74c3c;
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #84fab0, #8fd3f4);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: #2c3e50;
  cursor: pointer;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
  font-size: 18px;
}

</style>
